import React from "react";
import DataGrid, {
  Column,
  Selection,
  FilterRow,
  Paging,
  Pager,
  Toolbar,
  Item,
  Lookup,
} from "devextreme-react/data-grid";
import { formatMessage } from "devextreme/localization";
import { useScreenSize } from "../../../utils/media-query";

import ToolbarBefore from "../../../components/toolbar-before/ToolbarBefore";
import ToolbarAfter from "./ToolbarAfter";
import {
  ApprovalStatus,
  changeDisplayedName,
  RequestStatus,
} from "../../../common";

export default function TimeKeepingOnlineTableList({
  middleware,
  dataGrid,
  handleOpenPopup,
  dataSource,
  handleChangeSelectBox,
  filter,
  setFilter,
}) {
  const { isXSmall, isSmall } = useScreenSize();

  return (
    <div>
      <DataGrid
        id="gridContainer"
        height={document.documentElement.offsetHeight - 189}
        showBorders={true}
        showRowLines={true}
        hoverStateEnabled={true}
        rowAlternationEnabled={true}
        columnAutoWidth={true}
        columnResizingMode="widget"
        alignment="center"
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnHidingEnabled={true}
        ref={(e) => {
          dataGrid.current = e;
        }}
        dataSource={dataSource}
      >
        {/* <SearchPanel
        visible={true}
        width={240}
        className="datagrid-toolbar-search-panel"
        placeholder="Search..."
      /> */}
        <Selection
          mode="multiple"
          selectAllMode="page"
          showCheckBoxesMode="always"
        />
        <FilterRow visible={true} />
        <Paging defaultPageSize={10} />
        <Pager
          showPageSizeSelector={true}
          allowedPageSizes={[10, 20, 50, 100]}
          showInfo={true}
          visible={true}
        />
        <Column
          caption={formatMessage("EmployeeCode")}
          dataField="Employee.EmployeeCode"
          dataType="string"
          hidingPriority={isXSmall || isSmall ? 1 : false}
        />
        <Column
          caption={formatMessage("EmployeeName")}
          dataField="Employee.FullName"
          dataType="string"
        />
        <Column
          caption={formatMessage("DepartmentCode")}
          dataField="Employee.Department.DepartmentCode"
          dataType="string"
          hidingPriority={isXSmall ? 1 : false}
        />
        <Column
          caption={formatMessage("DepartmentName")}
          dataField="Employee.Department.DepartmentName"
          dataType="string"
          hidingPriority={isXSmall ? 1 : false}
        />
        <Column
          caption={formatMessage("PositionName")}
          dataField="Employee.Position.PositionName"
          dataType="string"
        />
        <Column
          caption={formatMessage("Date")}
          dataField="LogTime"
          dataType="date"
          format="dd/MM/yyyy HH:mm:ss"
          hidingPriority={isXSmall || isSmall ? 3 : false}
        />
        {/* <Column
          caption={formatMessage("LogTime")}
          dataField="LogTime"
          dataType="time"
          calculateCellValue={(rowData) => {
            return moment(rowData.LogTime).format("HH:mm:ss");
          }}
          // format="dd/MM/yyyy"
        /> */}
        <Column
          caption={formatMessage("Shift")}
          dataField="Shift.Name"
          dataType="string"
        />
        <Column
          caption={formatMessage("RequestStatus")}
          dataField="RequestStatus"
          hidingPriority={isXSmall || isSmall ? 3 : false}
        >
          <Lookup
            dataSource={RequestStatus}
            displayExpr={changeDisplayedName()}
            valueExpr="default"
          />
        </Column>
        <Column
          caption={formatMessage("LastApprovalStatus")}
          dataField="LastApprovalStatus"
          hidingPriority={isXSmall || isSmall ? 13 : false}
        >
          <Lookup
            dataSource={ApprovalStatus}
            displayExpr={changeDisplayedName()}
            valueExpr="default"
          />
        </Column>

        <Column
          caption={formatMessage("FirstApprovalName")}
          dataField="FirstApprovalName"
          dataType="string"
          hidingPriority={isXSmall || isSmall ? 9 : false}
        />
        <Column
          caption={formatMessage("LastApprovalName")}
          dataField="LastApprovalName"
          dataType="string"
          hidingPriority={isXSmall || isSmall ? 9 : false}
        />
        <Column
          caption={formatMessage("LastApprovalDate")}
          dataField="LastApprovalDate"
          dataType="date"
          format="dd/MM/yyyy"
          hidingPriority={isXSmall || isSmall ? 10 : false}
          width={120}
        />
        <Column
          caption={formatMessage("LastApprovalComments")}
          dataField="LastApprovalComments"
          dataType="string"
          hidingPriority={isXSmall || isSmall ? 11 : false}
        />
        <Column
          caption={formatMessage("CancelReason")}
          dataField="CancelReason"
          dataType="string"
          hidingPriority={isXSmall || isSmall ? 3 : false}
        />
        <Column
          caption={formatMessage("CancelDate")}
          dataField="CanceledDate"
          dataType="date"
          hidingPriority={isXSmall || isSmall ? 3 : false}
        />
        <Toolbar className="datagrid-toolbar-actions">
          <Item
            location="before"
            locateInMenu={isXSmall || isSmall ? "always" : "auto"}
            cssClass={"datagrid-toolbar-actions-dropdown"}
          >
            <ToolbarBefore
              middleware={middleware}
              filter={filter}
              setFilter={setFilter}
              handleChangeSelectBox={handleChangeSelectBox}
            />
          </Item>
          <Item
            location="after"
            locateInMenu={isXSmall || isSmall ? "always" : "auto"}
            cssClass={"datagrid-toolbar-actions-dropdown"}
          >
            <ToolbarAfter
              middleware={middleware}
              dataGrid={dataGrid}
              handleOpenPopup={handleOpenPopup}
            />
          </Item>
        </Toolbar>
      </DataGrid>
    </div>
  );
}
